import React from 'react'
import ProductionLineDelete from "./ProductionDelete";
import ProductionLineEdit from "./ProductionEdit";

const ProductionLineActions = ({record, updater}) => {

    return(
        <React.Fragment>
            <ProductionLineEdit production={record} updater={updater} />
            <ProductionLineDelete production={record} updater={updater} />
        </React.Fragment>
    )
}
export default ProductionLineActions